var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dashboard',{ref:"dash",attrs:{"uppy":_vm.uppyInstance,"props":_vm.uppyOptions,"plugins":['ImageEditor']}})
}
var staticRenderFns = []

export { render, staticRenderFns }